import { getStoredValue, HAS_ENTERED_HOME_KEY, storeValue } from '@sorrem-client/ui/shared/browser-storage';

/**
 * Whether Character Home has been entered since this login (it greets the
 * first entry differently). Tied to the session: every login starts without it.
 */
export function hasEnteredHomeThisSession(): boolean {
    return getStoredValue('session', HAS_ENTERED_HOME_KEY) === 'true';
}

/** Records the first entry; without storage, every entry just reads as the first. */
export function markHomeEnteredThisSession(): void {
    storeValue('session', HAS_ENTERED_HOME_KEY, 'true');
}
